module.exports = __webpack_public_path__ + "img/20210129_141206.bc66ff5d.jpg";